import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { goolgePlacesObj } from '../../constants/Global';
import { MapsSidebarService } from '../../maps-sidebar.service';

@Component({
  selector: 'app-place-filter',
  templateUrl: './place-filter.component.html',
  styleUrls: ['./place-filter.component.less'],
})
export class PlaceFilterComponent implements OnInit, AfterViewInit {

  placeFilterActiveSubscription: Subscription;
  google = goolgePlacesObj;
  closeOnClickRef: any;
  isPlacesOn: boolean = true;
  placesFilterChangedSubscription: any;

  constructor(public mapsSidebarService: MapsSidebarService, public elementRef: ElementRef) { }

  ngOnInit() {
    this.closeOnClickRef = this.closeOnOutsideClick.bind(this);
    this.placeFilterActiveSubscription = this.mapsSidebarService.placeFilterActiveStream.subscribe((value)=>{
      if(value) {
        document.addEventListener('click', this.closeOnClickRef, true);
      }
    });
  }

  ngAfterViewInit() {
    this.placesFilterChangedSubscription = (<any>window).Events.subscribe('placesFilterChanged', ()=>{
      this.isPlacesOn = (<any>window).mapData.placesFilterActive;
    });
  }

  closeOnOutsideClick(event: Event) {
    let w = (<any>window);
    if (event.target !== this.elementRef.nativeElement
        && !this.elementRef.nativeElement.contains(event.target)
        && !w.hasClass(event.target, 'layer-filter-sub-header')
        && !w.hasClass(event.target, 'toggle-layers-holder')
        && !w.hasClass(event.target, 'filter-counter')
        && !w.hasClass(event.target, 'filter-icon')
        && !w.hasClass(event.target, 'arrow-icon')) {
        this.closePlaceFilter();
        document.removeEventListener('click', this.closeOnClickRef, true);
    }
  }

  closePlaceFilter() {
    let w = (<any>window);
    this.mapsSidebarService.showPlaceFilter = false;
    w.localStorageHandler.updateSideBarToLS();
    w.Events.publish('detectChanges');
  }

  togglePlaces(event) {
    let w = (<any>window);
    w.apiGooglePlaces.toggleGooglePlacesFilter(event.target.id.split('-')[1], event.target.checked);
    w.Events.publish('detectChanges');
  }

  resetPlaceFilter() {
    let w = (<any>window);
    w.apiGooglePlaces.resetFilter();
    w.Events.publish('detectChanges');
  }

  isPlaceChecked(place) {
    return !!(<any>window).mapData.filteredGooglePlaces.find((id)=>{
      return id === place;
    });
  }

  togglePlaceVisibility(event) {
    let w = (<any>window);
    this.isPlacesOn = event.target.checked;
    w.apiGooglePlaces.toggleVisible(event.target.checked);
    w.localStorageHandler.updateMapDataLocalStorage();
    w.Events.publish('detectChanges');
  }

  isPlaceDisabled() {
    return ((<any>window).mapData.placesFilterActive !== undefined)? !((<any>window).mapData.placesFilterActive) : false;
  }

  removeSubscriptions() {
    this.placeFilterActiveSubscription && this.placeFilterActiveSubscription.unsubscribe();
    this.placesFilterChangedSubscription && this.placesFilterChangedSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.removeSubscriptions();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/components/place-filter/place-filter.component.ts